module.exports = __webpack_public_path__ + "static/media/IconTemplates_-73.133af4ff.svg";